import { Button } from 'antd';
import React from 'react';
import { CourseType } from '../../../types/course';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../../../types/user';
import { useTranslation } from 'react-i18next';

const CourseDetailsButton = ({ course }: { course: CourseType }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    return (
        <Button
            onClick={() => {
                navigate(`/app/course-drafts/${course.id}`);
            }}
            style={{ width: '100%' }}
        >
            {course.is_draft ? t('edit') : t('details')}
        </Button>
    );
};

const getActions = (course: CourseType, user: UserType) => {
    return <CourseDetailsButton key={'details'} course={course} />;
};

export default getActions;
